import organizations from '@redux/reducers/organizations';
import tasks from '@redux/reducers/tasks';
import workspaceCountersReducer from '@redux/reducers/workspaceCountersReducer';
import { combineReducers } from '@reduxjs/toolkit';
import mediaViewerReducer from './mediaViewerReducer';
import modalReducer from './modalReducer';
import workspaceReducer from './workspaceReducer';

export const rootReducer = combineReducers({
  organizations,
  workspace: workspaceReducer,
  tasks,
  modal: modalReducer,
  mediaViewer: mediaViewerReducer,
  workspaceCounters: workspaceCountersReducer
});
